import { Button } from '~/shared/components/Button';
import { Text } from '~/shared/components/Text';
import { ModuleContainer } from '../../shared/ModuleContainer';
import { Footer, PageSetter, Pagination, Section, StyledWrapper } from './styled';
import { SkeletonLoader } from '~/shared/components/SkeletonLoader';

import { useState } from 'react';
import { useUserProfile } from '~/services/shop/hooks';
import { useTranslations } from '~/services/umbraco/hooks';
import Table from './components/Table';

export default function M204UserList() {
    const [modal, setModal] = useState<'edit' | 'add' | 'delete' | ''>();
    const { data: currentUser, isLoading } = useUserProfile();
    const { translate } = useTranslations();

    if (isLoading || !currentUser) return <Skeleton />;

    return (
        <ModuleContainer>
            <Section>
                <Text as="h2" variant="display3">
                    {translate('mit-fog.userList.userAdministration')}
                </Text>
                <StyledWrapper>
                    <Text as="h3" variant={'display5'}>
                        {translate('mit-fog.userList.user')}
                    </Text>
                    <Button variant="fill" noIcon onClick={() => setModal('add')}>
                        {translate('mit-fog.userList.createUser')}
                    </Button>
                </StyledWrapper>
                <Table modal={modal} setModal={setModal} currentUser={currentUser} />
            </Section>
        </ModuleContainer>
    );
}

function Skeleton() {
    return (
        <ModuleContainer spacingTop="none" fullWidth>
            <Section>
                <SkeletonLoader width={300} height={38} />
                <StyledWrapper>
                    <SkeletonLoader width={300} height={38} />
                    <SkeletonLoader width={80} height={38} />
                </StyledWrapper>
                {Array.from({ length: 11 }).map((_, index) => (
                    <div key={index}>
                        <SkeletonLoader isFullWidth height={48} />
                    </div>
                ))}
                <Footer>
                    <PageSetter>
                        <SkeletonLoader height={40} width={150} />
                    </PageSetter>
                    <Pagination>
                        <SkeletonLoader height={40} width={40} />
                        <SkeletonLoader height={40} width={150} />
                        <SkeletonLoader height={40} width={40} />
                    </Pagination>
                </Footer>
            </Section>
        </ModuleContainer>
    );
}
